var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickviewmenusvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 61,
    viewBox: "0 0 69 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1591 23.3641C5.14962 26.1968 0 30.6024 0 35.5476C0 42.4783 10.0777 48.326 23.9944 50.3062V60.3L37.7056 47.9238L23.9944 35.5476V43.9943C13.1969 42.2617 6.85556 38.1156 6.85556 35.5476C6.85556 34.0312 9.08321 31.9327 13.1591 30.1146V23.3641Z",
    fill: "#9E69B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4001 30.1162C59.4737 31.9339 61.7 34.0316 61.7 35.5476C61.7 37.8062 56.6955 41.3953 47.9889 43.3755V49.7183C60.089 47.3359 68.5556 41.8904 68.5556 35.5476C68.5556 30.6032 63.4075 26.1981 55.4001 23.3654V30.1162Z",
    fill: "#9E69B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7491 18.6525L50.8847 9.57627M34.7491 18.6525V36.8051M34.7491 18.6525L18.6135 9.57627M34.7491 0.5L50.8847 9.57627V27.7288L34.7491 36.8051L18.6135 27.7288V9.57627L34.7491 0.5Z",
    stroke: "#9E69B4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickviewmenusvg);
export default __webpack_public_path__ + "static/media/quickviewmenusvg.c9152f9ab89e39a4f88cb19df12a1ed6.svg";
export { ForwardRef as ReactComponent };